// @flow

//
// React
//
import React, { useState, useContext, useEffect, useLayoutEffect } from "react";

//
// React Router
//
import { Routes, Route, useParams, useNavigate, useLocation } from 'react-router-dom';

//
// Redux Fantasy
//
import {
    useLocalSelector,
    useDispatchLocal,
} from '../../../../../lib/redux-fantasy-reducers';

//
// Material UI
//
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { useTheme, useMediaQuery } from '@mui/material';

//
// Hal Forms
//
import HalFormsContext from '../../../../../lib/trix-web-hal-forms/context/HalFormsContext';
import HalFormsComponent from '../../../../../lib/trix-web-hal-forms/component/HalFormsComponent';

import {
    getActionFactory,
	getSelector,
} from '../../../../../lib/trix-web-hal-forms/tools/halFormsRedux';

//
// Props
//
type Props = {
    //
    // Hal forms template
    //
    __halFormsTemplate: any,

    //
    // Ducks
    //
    __ducks: {
        actions: any,
        selectors: any,
    },

    //
    // Refs
    //
    __dataSourcesRef: any,

    //
    // Components registry
    //
    __componentsRegistry: any,

    //
    // Data Source Extender props (in case data source set)
    //
    __dataSourceExtender: {
        dataSource: any,
        loadData: (params: any) => void,
        isDataLoadNeeded: (params: any) => boolean,
        isLoadingData: boolean,
        params: any,
        data: any,
    },

    //
    // Container
    //
    container: any,

    //
    // Data
    //
    data: any,

    //
    // Handlers
    //
    onChange: (value: any, meta: any) => void,
    onClose: () => void,
    onDataLoad: (data: any) => void,
} // End of Props

const ListStocksSection = (props: Props) => {
    // detect hal form components
    let stockItemsHalFormTemplate: any = null;
    for (let i in props.__halFormsTemplate.components) {
        if (props.__halFormsTemplate.components[i].name === 'listStocksTable') {
            stockItemsHalFormTemplate = props.__halFormsTemplate.components[i];
        }
    }

    if (!props.container || !props.container.id) {
        return null;
    }

    return (
        <>
            <div>
                <Typography 
                    variant='subtitle1' 
                    sx={{
                        fontWeight: 200,
                        lineHeight: 2,
                    }}
                >
                    {stockItemsHalFormTemplate.title}
                </Typography>
            </div>
            <Paper>
                <HalFormsComponent
                    __componentsRegistry={props.__componentsRegistry}
                    __ducks={props.__ducks}
                    __dataSourcesRef={props.__dataSourcesRef}
                    __halFormsTemplate={props.__halFormsTemplate}
                    onChange={props.onChange}
                    onClose={props.onClose}
                    c={stockItemsHalFormTemplate}
                    container={props.container}
                    data={props.data}
                />
            </Paper>
        </>
    );
}

const CurrentRetailSalePaymentSection = (props: Props) => {
    // detect hal form components
    let currentRetailSalePaymentForm: any = null;
    let paymentTransactionsTable: any = null;
    for (let i in props.__halFormsTemplate.components) {
        if (props.__halFormsTemplate.components[i].name === 'currentRetailSalePaymentForm') {
            currentRetailSalePaymentForm = props.__halFormsTemplate.components[i];
        }
        if (props.__halFormsTemplate.components[i].name === 'paymentTransactionsTable') {
            paymentTransactionsTable = props.__halFormsTemplate.components[i];
        }
    }


    return (
        <>
            <div>
                <Typography 
                    variant='subtitle1' 
                    sx={{
                        fontWeight: 200,
                        lineHeight: 2,
                    }}
                >
                    {currentRetailSalePaymentForm.title}
                </Typography>
            </div>
            <Paper>
                <HalFormsComponent
                    __componentsRegistry={props.__componentsRegistry}
                    __ducks={props.__ducks}
                    __dataSourcesRef={props.__dataSourcesRef}
                    __halFormsTemplate={props.__halFormsTemplate}
                    onChange={props.onChange}
                    onClose={props.onClose}
                    c={currentRetailSalePaymentForm}
                    container={props.container}
                    data={props.data}
                />

                <HalFormsComponent
                    __componentsRegistry={props.__componentsRegistry}
                    __ducks={props.__ducks}
                    __dataSourcesRef={props.__dataSourcesRef}
                    __halFormsTemplate={props.__halFormsTemplate}
                    onChange={props.onChange}
                    onClose={props.onClose}
                    c={paymentTransactionsTable}
                    container={props.container}
                    data={props.data}
                />
            </Paper>
        </>
    );
}

const MainSection = (props: Props) => {
    return (
        <React.Fragment>
            <Routes>
                <Route 
                    index
                    element={
                        <ListStocksSection {...props} />
                    }
                />
                <Route 
                    path='pay'
                    element={
                        <CurrentRetailSalePaymentSection {...props} />
                    }
                />
            </Routes>
        </React.Fragment>
    );
}


const CurrentRetailSaleSection = (props: Props) => {
    // detect hal form components
    let currentRetailSaleHeaderHalFormTemplate:any = null;
    let currentRetailSaleLinesHalFormTemplate:any = null;
    for (let i in props.__halFormsTemplate.components) {
        if (props.__halFormsTemplate.components[i].identifier === 'currentRetailSaleHeaderForm') {
            currentRetailSaleHeaderHalFormTemplate = props.__halFormsTemplate.components[i];
        }
        if (props.__halFormsTemplate.components[i].identifier === 'currentRetailSaleLinesTable') {
            currentRetailSaleLinesHalFormTemplate = props.__halFormsTemplate.components[i];
        }
    }

    return (
        <>
            <div>
                <Typography 
                    variant='subtitle1' 
                    sx={{
                        fontWeight: 200,
                        lineHeight: 2,
                    }}
                >
                    {currentRetailSaleHeaderHalFormTemplate.title}
                </Typography>
            </div>
            <Paper>
                <Stack spacing={0}>
                    <HalFormsComponent
                        __componentsRegistry={props.__componentsRegistry}
                        __ducks={props.__ducks}
                        __dataSourcesRef={props.__dataSourcesRef}
                        __halFormsTemplate={props.__halFormsTemplate}
                        onChange={props.onChange}
                        onClose={props.onClose}
                        c={currentRetailSaleHeaderHalFormTemplate}
                        container={props.container}
                        data={props.data}
                    />
                    <HalFormsComponent
                        __componentsRegistry={props.__componentsRegistry}
                        __ducks={props.__ducks}
                        __dataSourcesRef={props.__dataSourcesRef}
                        __halFormsTemplate={props.__halFormsTemplate}
                        onChange={props.onChange}
                        onClose={props.onClose}
                        c={currentRetailSaleLinesHalFormTemplate}
                        container={props.container}
                        data={props.data}
                    />
                </Stack>
            </Paper>
        </>
    );
}

const OpenRetailSalesSection = (props: Props) => {
    let openRetailSalesHalFormTemplate: any = null;
    for (let i in props.__halFormsTemplate.components) {
        if (props.__halFormsTemplate.components[i].name === 'openRetailSalesTable') {
            openRetailSalesHalFormTemplate = props.__halFormsTemplate.components[i];
        }
    }

    return (
        <>
            <div>
                <Typography 
                    variant='subtitle1' 
                    sx={{
                        fontWeight: 200,
                        lineHeight: 2,
                    }}
                >
                    {openRetailSalesHalFormTemplate.title}
                </Typography>
            </div>

            <Paper>
                <HalFormsComponent
                    __componentsRegistry={props.__componentsRegistry}
                    __ducks={props.__ducks}
                    __dataSourcesRef={props.__dataSourcesRef}
                    __halFormsTemplate={props.__halFormsTemplate}
                    onChange={props.onChange}
                    onClose={props.onClose}
                    c={openRetailSalesHalFormTemplate}
                    container={props.container}
                    data={props.data}
                />
            </Paper>
        </>
    );
}

const ManageRetailSaleContainerMobile = (props: Props): any => {
    return(
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <MainSection {...props} />
            </Grid>
            <Grid item xs={12}>
                <CurrentRetailSaleSection {...props} />
            </Grid>
            <Grid item xs={12}>
                <OpenRetailSalesSection {...props} />
            </Grid>
        </Grid>
    );
}

const ManageRetailSaleContainerTablet = (props: Props): any => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={7}>
                <Grid container direction='column' spacing={2}>
                    <Grid item>
                        <MainSection {...props} />
                    </Grid>
                    <Grid item>
                        <OpenRetailSalesSection {...props} />
                    </Grid>
                </Grid>
            </Grid>

            <Grid item xs={5}>
                <CurrentRetailSaleSection {...props} />
            </Grid>
        </Grid>
    );
}

const ManageRetailSaleContainerDesktop = (props: Props): any => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={3}>
                <OpenRetailSalesSection {...props} />
            </Grid>

            <Grid item xs={5}>
                <MainSection {...props} />
            </Grid>

            <Grid item xs={4}>
                <CurrentRetailSaleSection {...props} />
            </Grid>
        </Grid>
    );
}

const ManageRetailSaleContainerRoot = (props: Props): any => {
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.only('xs'));
    const isSm = useMediaQuery(theme.breakpoints.only('sm'));
    const isMd = useMediaQuery(theme.breakpoints.only('md'));
    const isLg = useMediaQuery(theme.breakpoints.only('lg'));
    const isXl = useMediaQuery(theme.breakpoints.only('xl'));
    let currentBreakpoint = '';
    if (isXs) currentBreakpoint = 'XS';
    if (isSm) currentBreakpoint = 'SM';
    if (isMd) currentBreakpoint = 'MD';
    if (isLg) currentBreakpoint = 'LG';
    if (isXl) currentBreakpoint = 'XL';
    
    // trigger layout re-render while resize from big to small, while inside same breakpoint (md)
    const [ key, setKey ] = React.useState(0);
    React.useEffect(() => {
        const handleResize = () => setKey(prev => prev + 1);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return(
        <>
            {(isXs) && <ManageRetailSaleContainerMobile key={`mobile_${key}`} {...props} />}
            {(isMd || isSm) && <ManageRetailSaleContainerTablet key={`tablet_${key}`} {...props} />}
            {(isLg || isXl) && <ManageRetailSaleContainerDesktop key={`desktop_${key}`} {...props} />}
        </>
    );
}


//
// Component
//
const ManageRetailSaleContainer = (props: Props): any => {
    //
    // Hooks
    //
    const { sendClientEvent } = useContext(HalFormsContext);
    const { id } = useParams();

    useEffect(() => {
        const _id = (id) ? id : '';

        if (props.data.id !== _id) {
            sendClientEvent('manageRetailSaleContainer', {
                name: 'RELOAD',
                payload: { id }
            });
        }
    }, [ sendClientEvent, props.data, id ]);

    return(
        <ManageRetailSaleContainerRoot {...props} />
    );
}

export default ManageRetailSaleContainer;